module.exports = __webpack_public_path__ + "media/2_2-5.dcd97ac6.mp3";